
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/perencanaan/ajukan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/perencanaan/ajukan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/perencanaan/ajukan"])
      });
    }
  